<template>

    <button class="w-2/4 bg-blue-600 text-white rounded" @click="$emit('submit')">
        {{ $t('text.apply')}}
    </button>

</template>

<script>
    export default {
        name: "MissionProfileApplyButton"
    }
</script>

<style scoped>

</style>